module.exports = __webpack_public_path__ + "media/images/icons/journal_entries-cebfb0941fe0a615789dfd71a503c1d1.svg";